import React, { useState } from 'react';
import { Modal, Button, Table, Badge, Alert, Spinner } from 'react-bootstrap';
import { useMutation } from 'react-query';
import { toast } from 'react-toastify';
import { BANGDANHGIA_HUONGDANTHUCHANH_API } from '../../../../utils/apiUrl';
import { PostFormData } from '../../../../utils/httpProvider';

const ImportBangDanhGiaThucHanhModal = ({ show, onHide, lopId, batchId, onApply }) => {
    const [file, setFile] = useState(null);
    const [previewData, setPreviewData] = useState([]);

    const previewMutation = useMutation(
        (formData) => PostFormData(`${BANGDANHGIA_HUONGDANTHUCHANH_API.IMPORT_EXCEL}/${lopId}/${batchId}`, formData),
        {
            onSuccess: (res) => {
                const list = res?.$values || res || [];
                setPreviewData(list);
                toast.success(`Đã đọc ${list.length} dòng dữ liệu đánh giá từ Excel.`);
            },
            onError: (err) => {
                toast.error(err?.response?.data?.message || err?.message || "Lỗi khi đọc file Excel!");
            }
        }
    );

    const handleFileChange = (e) => {
        if (e.target.files && e.target.files[0]) {
            const selectedFile = e.target.files[0];
            setFile(selectedFile);
            const formData = new FormData();
            formData.append('file', selectedFile);
            previewMutation.mutate(formData);
        }
    };

    const handleApply = () => {
        if (!previewData || previewData.length === 0) {
            toast.warning("Không có dữ liệu để áp dụng!");
            return;
        }

        if (onApply) {
            onApply(previewData);
        }
        toast.success(`Đã điền dữ liệu nhận xét cho các học viên từ file Excel!`);
        handleClose();
    };

    const handleClose = () => {
        setFile(null);
        setPreviewData([]);
        onHide();
    };

    return (
        <Modal show={show} onHide={handleClose} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title className="text-primary font-weight-bold" style={{ fontSize: '18px' }}>
                    <i className="fas fa-file-excel mr-2 text-success"></i>
                    Nhập Nhận Xét & Đánh Giá Từ File Excel
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Alert variant="info" className="small mb-3">
                    <i className="fas fa-info-circle mr-1"></i>
                    Hệ thống sẽ tự động nhận diện các cột: <strong>Họ và tên, Năng lực chuyên môn, Ý thức kỷ luật, Kết quả (Đạt/Không đạt), Ghi chú</strong>.
                </Alert>

                <div className="mb-3">
                    <label className="font-weight-bold mb-1">Chọn file Excel đánh giá (.xlsx, .xls):</label>
                    <input
                        type="file"
                        className="form-control"
                        accept=".xlsx, .xls"
                        onChange={handleFileChange}
                        disabled={previewMutation.isLoading}
                    />
                </div>

                {previewMutation.isLoading && (
                    <div className="text-center py-4">
                        <Spinner animation="border" variant="primary" size="sm" />
                        <span className="ml-2 text-muted">Đang phân tích file Excel...</span>
                    </div>
                )}

                {previewData.length > 0 && (
                    <div className="mt-3">
                        <h6 className="font-weight-bold text-dark mb-2">
                            <i className="fas fa-eye mr-1 text-info"></i>
                            Xem trước dữ liệu ({previewData.length} dòng):
                        </h6>
                        <div className="table-responsive" style={{ maxHeight: '350px', overflowY: 'auto' }}>
                            <Table bordered size="sm" hover className="text-nowrap mb-0">
                                <thead className="thead-light">
                                    <tr>
                                        <th>#</th>
                                        <th>Họ và tên</th>
                                        <th>CCCD</th>
                                        <th>Năng lực chuyên môn</th>
                                        <th>Ý thức kỷ luật</th>
                                        <th>Kết quả</th>
                                        <th>Ghi chú</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {previewData.map((row, idx) => (
                                        <tr key={idx}>
                                            <td>{idx + 1}</td>
                                            <td className="font-weight-bold text-dark">{row.hoTen}</td>
                                            <td>{row.soCccd || "—"}</td>
                                            <td>{row.nangLucChuyenMon || "—"}</td>
                                            <td>{row.yThucKyLuat || "—"}</td>
                                            <td>
                                                {row.ketQuaDanhGia ? (
                                                    <Badge variant={row.ketQuaDanhGia.toLowerCase().includes('không') ? "danger" : "success"}>
                                                        {row.ketQuaDanhGia}
                                                    </Badge>
                                                ) : "—"}
                                            </td>
                                            <td>{row.nhanXetChung || "—"}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    </div>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Hủy bỏ
                </Button>
                <Button
                    variant="success"
                    onClick={handleApply}
                    disabled={previewData.length === 0 || previewMutation.isLoading}
                >
                    <i className="fas fa-check mr-1"></i> Áp dụng vào bảng
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ImportBangDanhGiaThucHanhModal;
